import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import { auth } from "@/plugins/firebase";

Vue.use(VueRouter)

const router = new VueRouter({
  scrollBehavior: () => ({ x: 0, y: 0 }),
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(
  async (to, from, next) => {
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    await auth.onAuthStateChanged(user => {
      console.log(user)
      if (requiresAuth && !user) {
        next({
          path: '/sign-in', query: {
            redirect: to.path
          }
        })
      } else {

        next();
      }
    })
  }
)

export default router
